import client from './client'
import {
  WebhookProps,
  ForwardingConfigDetails,
  NotificationListResponse,
  MessageChannelTypes,
} from '@/types'

export const getConfigList = (params: { page: number; size: number }) => {
  return client<NotificationListResponse<ForwardingConfigDetails>>({
    url: 'msg-forwarding',
    method: 'GET',
    params,
  })
}

export const getConfigDetails = (id: number) => {
  return client<ForwardingConfigDetails>({
    url: `msg-forwarding/${id}`,
    method: 'GET',
  })
}

export const createConfig = (data: ForwardingConfigDetails) => {
  return client<unknown>({ url: 'msg-forwarding', method: 'POST', data })
}

export const updateConfig = (data: ForwardingConfigDetails) => {
  return client<unknown>({
    url: `msg-forwarding/${data?.id}`,
    method: 'PUT',
    data,
  })
}

export const enableConfig = (data: { id: number; enabled: 1 | 0 }) => {
  return client<unknown>({
    url: `msg-forwarding/${data?.id}/enabled`,
    method: 'PUT',
    data,
  })
}

export const deleteConfig = (id: number) => {
  return client<unknown>({ url: `msg-forwarding/${id}`, method: 'DELETE' })
}

export type MessageType = 1 | 2 | 3 | 4 | 5; // 1:邮箱；2:钉钉；3:企业微信；4:飞书

export const testMessage = (data: {
  id?: number;
  channel?: MessageChannelTypes;
  receives?: WebhookProps[];
}) => {
  return client<{ addresses: string[] }>({
    url: 'msg-forwarding/test',
    method: 'POST',
    data,
  })
}
